import { useSession } from "hooks/useSession";
import React, { useState, useEffect } from "react";
import { fetchWrapper } from "utils/apiFetch";

function MobileRecharge() {
  const [mobile, setMobile] = useState("");
  const [amount, setAmount] = useState("");
  const [pin, setMPIN] = useState("");
  const [operator, setOperator] = useState("");
  const [circle, setCircle] = useState("");
  const [operators, setOperators] = useState([]);
  const [circles, setCircles] = useState([]);
  const [error, setError] = useState("");
  const [rechargeLoading, setRechargeLoading] = useState(false);
 const {userid} =useSession();

  
  // Plan-related states
  const [planData, setPlanData] = useState(null);
  const [activeTab, setActiveTab] = useState("TOPUP");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [newPlansData, setNewPlansData] = useState(null);
const [newPlansLoading, setNewPlansLoading] = useState(false);
const [newSearchTerm, setNewSearchTerm] = useState("");

  // Helper function to create valid CSS selector IDs
  const createValidId = (text) => {
    return text.replace(/[^a-zA-Z0-9]/g, '_').replace(/^[0-9]/, 'tab_$&');
  };

  // Fetch Operators & Circles on page load
  useEffect(() => {
    const fetchData = async () => {
      try {
        const opRes = await fetchWrapper("https://pro.mokshiq.in/get_operator");
        const opJson = opRes;
        setOperators(opJson.data || []);

        const circleRes = await fetchWrapper("https://pro.mokshiq.in/get_circle");
        const circleJson = circleRes;
        setCircles(circleJson.data || []);
      } catch (err) {
        console.error("Error loading operators/circles", err);
      }
    };

    fetchData();
  }, []);

  // Auto-detect Operator & Circle when mobile reaches 10 digits
  useEffect(() => {
    if (mobile.length === 10) {
      const fetchOperatorCircle = async () => {
        try {
          const lookupRes = await fetchWrapper(
            `https://pro.mokshiq.in/fetch_operator_circle?phone=${mobile}`
          );
          
          
          
          const lookupJson = lookupRes;

          if (lookupJson?.status && lookupJson?.data?.records) {
            const operatorName = lookupJson.data.records.Operator?.trim();
            const circleName = lookupJson.data.records.comcircle?.trim();

            console.log("Auto-detected:", { operatorName, circleName });

            // Find matching operator
            const matchedOperator = operators.find(
              (op) => op.name.toLowerCase() === operatorName.toLowerCase()
            );
            if (matchedOperator) {
              setOperator(matchedOperator.name);
            }

            // Find matching circle
            const matchedCircle = circles.find(
              (c) => c.name.toLowerCase() === circleName.toLowerCase()
            );
            if (matchedCircle) {
              setCircle(matchedCircle.name);
            }
          } else {
            console.log("No valid data in response:", lookupJson);
          }
        } catch (err) {
          console.error("Lookup failed:", err);
        }
      };

      fetchOperatorCircle();
    } else {
      // Clear operator and circle if mobile number is not complete
      if (mobile.length < 10) {
        setOperator("");
        setCircle("");
      }
    }
  }, [mobile, operators, circles]);

  // Fetch plan data
  const fetchPlanData = async () => {
    if (!operator || !circle) {
      alert("Please select operator and circle first");
      return;
    }
    
    setLoading(true);
    try {
      const response = await fetchWrapper(
        `https://pro.mokshiq.in/fetch_recharge_plan?operator=${operator}&circle=${circle}&phone=${mobile}`
      );
      const data = response;
      setPlanData(data.data);
    } catch (err) {
      console.error("Error fetching plans:", err);
      // Fallback sample data
      setPlanData({
        "TOPUP": [
          {
            "rs": "20",
            "desc": "Talktime of Rs. 14.95",
            "validity": "N/A",
            "last_update": "04-09-2025"
          }
        ]
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle mobile number input (only digits)
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setMobile(value);
  };

  // Handle plan selection
  const handlePlanSelect = (planAmount) => {
    setAmount(planAmount);
    const offcanvasElement = document.getElementById('offcanvasBottom1');
    if (offcanvasElement && window.bootstrap) {
      const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  };

  // Filter plans
  const filterPlans = (plans) => {
    if (!searchTerm) return plans;
    return plans.filter(plan => 
      plan.rs.includes(searchTerm) || 
      plan.desc.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };
  const showToast = (message, type = "primary") => {
    const alertDiv = document.createElement("div");
    alertDiv.className = `alert alert-${type} alert-dismissible cookies-alert position-fixed top-0 end-0 m-3 shadow`;
    alertDiv.setAttribute("role", "alert");
    alertDiv.style.zIndex = 2000;

    alertDiv.innerHTML = `
      <div class="d-flex justify-content-between align-items-center">
        <p class="mb-0 flex-grow-1">${message}</p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    `;
    document.body.appendChild(alertDiv);
    setTimeout(() => alertDiv?.remove(), 3000);
  };
  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (mobile.length !== 10) {
      setError("Mobile number must be 10 digits.");
      return;
    }
    if (!amount) {
      setError("Please enter recharge amount.");
      return;
    }
    if (!operator) {
      setError("Please select operator.");
      return;
    }
    if (!circle) {
      setError("Please select circle.");
      return;
    }
    setRechargeLoading(true);
    try {
        const formData = new FormData();
        formData.append("number", mobile);       // e.g., 6394856756
        formData.append("operator", operator);   // e.g., Vodafone
        formData.append("circle", circle);       // e.g., UP East
        formData.append("amount", amount);       // e.g., 10
        formData.append("user_id", userid);           // example user id
        formData.append("pin", pin); 
        formData.append("lat", "28.58990012778803");           // example user id
        formData.append("long", "77.381162088311");             // optional if required
    
        const data = await fetchWrapper("https://pro.mokshiq.in/create_mobile_recharge", {
          method: "POST",
           headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
          body: formData,
        });
    
       
        
        if (data.status) {
            showToast(data.message || "Success!", "success");
            setMobile("");
                        setAmount("");
                        setOperator("");
                        setCircle("");
                        setMPIN("");
                        setError("");
        } else {
            showToast(data.message || "Something went wrong!", "danger");
        }
      } catch (err) {
        console.error("Recharge API Error:", err);
        showToast( "Something went wrong!", "danger");
      }
      finally {
      setRechargeLoading(false); // STOP loading
  }
  };
  const fetchNewPlans = async () => {
    if (!operator || !circle) {
      alert("Please select operator and circle first");
      return;
    }
  
    setNewPlansLoading(true);
    try {
      const response = await fetchWrapper(`https://pro.mokshiq.in/recharge_roffer?operator=${operator}&circle=${circle}&phone=${mobile}`);
      const data = response;
      if(data.status) {
        setNewPlansData(data.data);
      } else {
        setNewPlansData([]);
      }
    } catch (err) {
      console.error("Error fetching new plans:", err);
      setNewPlansData([]);
    } finally {
      setNewPlansLoading(false);
    }
  };
  
  // Filter function for new plans
  const filterNewPlans = (plans) => {
    if (!newSearchTerm) return plans;
    return plans.filter(plan => 
      plan.rs.includes(newSearchTerm) || 
      plan.desc.toLowerCase().includes(newSearchTerm.toLowerCase())
    );
  };
  
  // Handle selection from new plans
  const handleNewPlanSelect = (planAmount) => {
    setAmount(planAmount);
    const offcanvasElement = document.getElementById('offcanvasBottom2');
    if (offcanvasElement && window.bootstrap) {
      const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasElement);
      if (bsOffcanvas) {
        bsOffcanvas.hide();
      }
    }
  };

  return (
    <main>
      <div className="container-fluid">
      <div className="row m-1">
          <div className="col-12 ">
            <h4 className="main-title">Mobile Recharge</h4>
            <ul className="app-line-breadcrumbs mb-3">
              <li>
                <a className="f-s-14 f-w-500" href="#">
                  <span>
                    <i className="ph-duotone ph-briefcase-metal f-s-16"></i>{" "}
                    Services
                  </span>
                </a>
              </li>
              <li className="active">
                <a className="f-s-14 f-w-500" href="#">
                  Mobile Recharge
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Form Section */}
        <div className="row">
          <div className="col-12">
            <div className="card">
                {rechargeLoading && (
  <div 
    className="page-loader-overlay d-flex justify-content-center align-items-center"
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255,255,255,0.7)',
      zIndex: 3000,
    }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
)}
              <div className="card-body">
                <form className="app-form" onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Mobile Number */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Mobile Number</label>
                        <input
                          className="form-control"
                          placeholder="Enter Your Mobile Number"
                          value={mobile}
                          onChange={handleMobileChange}
                          required
                          type="text"
                          maxLength="10"
                        />
                      </div>
                    </div>

                    {/* Recharge Amount */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Recharge Amount</label>
                        <input
                          className="form-control"
                          placeholder="Enter Your Recharge Amount"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          required
                          type="text"
                        />
                      </div>
                      <div className="text-end">
                        <button 
                          aria-controls="offcanvasBottom2"
                          className="btn btn-light-primary m-2"
                          data-bs-target="#offcanvasBottom2"
                          data-bs-toggle="offcanvas"
                          type="button"
                          onClick={fetchNewPlans}
                        >
                          Fetch R Offer
                        </button>
                        <button
                          aria-controls="offcanvasBottom1" 
                          className="btn btn-light-primary m-2"
                          data-bs-target="#offcanvasBottom1"
                          data-bs-toggle="offcanvas" 
                          type="button"
                          onClick={fetchPlanData}
                        >
                          Fetch Plan
                        </button>
                      </div>
                    </div>

                    {/* Operator Dropdown */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Select Operator</label>
                        <select
                          className="form-select"
                          value={operator}
                          onChange={(e) => setOperator(e.target.value)}
                          required
                        >
                          <option value="">-- Select Operator --</option>
                          {operators.map((op, i) => (
                            <option key={i} value={op.name}>
                              {op.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Circle Dropdown */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Select Circle</label>
                        <select
                          className="form-select"
                          value={circle}
                          onChange={(e) => setCircle(e.target.value)}
                          required
                        >
                          <option value="">-- Select Circle --</option>
                          {circles.map((c, i) => (
                            <option key={i} value={c.name}>
                              {c.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Transaction Pin */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Transaction Pin</label>
                        <input
                          className="form-control"
                          placeholder="Enter Your Transaction Pin"
                          value={pin}
                          onChange={(e) => setMPIN(e.target.value)}
                          required
                          type="password"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Error Message */}
                  {error && (
                    <div className="col-md-12">
                      <p className="text-danger">{error}</p>
                    </div>
                  )}

                  {/* Buttons */}
                  <div className="col-md-12 text-end">
                    <button className="btn btn-primary" type="submit">
                      Submit
                    </button>
                    <button
                      className="btn btn-secondary ms-2"
                      type="button"
                      onClick={() => {
                        setMobile("");
                        setAmount("");
                        setOperator("");
                        setCircle("");
                        setError("");
                      }}
                    >
                      Reset
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Offcanvas for Plan Selection */}
        <div 
          className="offcanvas offcanvas-bottom"
          id="offcanvasBottom1"
          tabIndex="-1"
          style={{ height: '80vh' }}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title">Select Recharge Plan</h5>
            <button 
              className="btn-close text-reset fs-5"
              data-bs-dismiss="offcanvas"
              type="button"
            ></button>
          </div>
          <div className="offcanvas-body">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : planData ? (
              <>
                {/* Search Box */}
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search plans..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>

                {/* Tabs */}
                <ul className="nav nav-tabs mb-3">
                  {Object.keys(planData).map((category) => {
                    const validId = createValidId(category);
                    return (
                      <li className="nav-item" key={category}>
                        <button
                          className={`nav-link ${activeTab === category ? 'active' : ''}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#${validId}`}
                          type="button"
                          onClick={() => setActiveTab(category)}
                        >
                          {category.replace(/[^a-zA-Z]/g, ' ')}
                        </button>
                      </li>
                    );
                  })}
                </ul>

                {/* Tab Content */}
                <div className="tab-content">
                  {Object.entries(planData).map(([category, plans]) => {
                    const validId = createValidId(category);
                    return (
                      <div
                        key={category}
                        className={`tab-pane fade ${activeTab === category ? 'show active' : ''}`}
                        id={validId}
                      >
                        <div className="row g-3">
                          {filterPlans(plans).map((plan, index) => (
                            <div key={index} className="col-12">
                              <div 
                                className="card plan-card" 
                                style={{ cursor: 'pointer' }}
                                onClick={() => handlePlanSelect(plan.rs)}
                              >
                                <div className="card-body">
                                  <div className="d-flex justify-content-between align-items-start">
                                    <div className="flex-grow-1">
                                      <h6 className="card-title text-primary">
                                        Rs.{plan.rs}
                                      </h6>
                                      <p className="card-text text-muted small mb-2">
                                        {plan.desc}
                                      </p>
                                      <div className="d-flex justify-content-between">
                                        <small className="text-success">
                                          Validity: {plan.validity}
                                        </small>
                                        <small className="text-muted">
                                          Updated: {plan.last_update}
                                        </small>
                                      </div>
                                    </div>
                                    <button 
                                      className="btn btn-sm btn-outline-primary ms-3"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handlePlanSelect(plan.rs);
                                      }}
                                    >
                                      Select
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        
                        {filterPlans(plans).length === 0 && (
                          <div className="text-center py-4">
                            <p className="text-muted">No plans found matching your search.</p>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">Click "Fetch R Offer" to load available plans.</p>
              </div>
            )}
          </div>
        </div>
        {/* Offcanvas for New Plans */}
<div 
  className="offcanvas offcanvas-bottom"
  id="offcanvasBottom2"
  tabIndex="-1"
  style={{ height: '80vh' }}
>
  <div className="offcanvas-header">
    <h5 className="offcanvas-title">Select Data/OTT Pack</h5>
    <button 
      className="btn-close text-reset fs-5"
      data-bs-dismiss="offcanvas"
      type="button"
    ></button>
  </div>
  <div className="offcanvas-body">
    {newPlansLoading ? (
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ) : newPlansData && newPlansData.length > 0 ? (
      <>
        {/* Search Box */}
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search plans..."
            value={newSearchTerm}
            onChange={(e) => setNewSearchTerm(e.target.value)}
          />
        </div>

        <div className="row g-3">
          {filterNewPlans(newPlansData).map((plan, index) => (
            <div key={index} className="col-12">
              <div 
                className="card plan-card" 
                style={{ cursor: 'pointer' }}
                onClick={() => handleNewPlanSelect(plan.rs)}
              >
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start">
                    <div className="flex-grow-1">
                      <h6 className="card-title text-primary">
                        Rs.{plan.rs}
                      </h6>
                      <p className="card-text text-muted small mb-2">
                        {plan.desc}
                      </p>
                    </div>
                    <button 
                      className="btn btn-sm btn-outline-primary ms-3"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleNewPlanSelect(plan.rs);
                      }}
                    >
                      Select
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filterNewPlans(newPlansData).length === 0 && (
          <div className="text-center py-4">
            <p className="text-muted">No plans found matching your search.</p>
          </div>
        )}
      </>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">Click "Fetch New Plans" to load available packs.</p>
      </div>
    )}
  </div>
</div>

      </div>

      <style jsx>{`
        .plan-card:hover {
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          transform: translateY(-2px);
          transition: all 0.3s ease;
        }
        
        .offcanvas-body {
          max-height: calc(80vh - 60px);
          overflow-y: auto;
        }
      `}</style>
      
    </main>
  );
}

export default MobileRecharge;
